import React, { useMemo } from "react";
import { COLORS } from "../constants";

export default function Benches() {
  const benchSpots = useMemo(
    () => [
      { x: 12, z: 0, rot: Math.PI / 2 },
      { x: -12, z: 0, rot: -Math.PI / 2 },
      { x: 0, z: 12, rot: 0 },
      { x: 0, z: -12, rot: Math.PI },
      { x: 18, z: 18, rot: -Math.PI / 4 },
      { x: -18, z: 18, rot: Math.PI / 4 },
      { x: 18, z: -18, rot: (-3 * Math.PI) / 4 },
      { x: -18, z: -18, rot: (3 * Math.PI) / 4 },
    ],
    []
  );

  return (
    <group>
      {benchSpots.map((b, i) => (
        <group key={i} position={[b.x, 0, b.z]} rotation={[0, b.rot, 0]}>
          <mesh castShadow receiveShadow position={[0, 0.5, 0]}>
            <boxGeometry args={[2.4, 0.12, 0.55]} />
            <meshStandardMaterial color={COLORS.woodBench} roughness={0.85} />
          </mesh>
          <mesh receiveShadow position={[0, 0.95, -0.22]}>
            <boxGeometry args={[2.4, 0.7, 0.1]} />
            <meshStandardMaterial color={COLORS.woodBench} roughness={0.85} />
          </mesh>
          {[-1, 1].map((s) => (
            <mesh key={s} receiveShadow position={[s * 1.0, 0.25, 0]}>
              <boxGeometry args={[0.12, 0.5, 0.55]} />
              <meshStandardMaterial color={COLORS.navyDeep} roughness={0.6} metalness={0.3} />
            </mesh>
          ))}
        </group>
      ))}
    </group>
  );
}
